import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/hooks/useAuthContext';

/**
 * Auth callback page — MSAL processes the redirect here.
 * Once authenticated, redirects to dashboard.
 * While loading, shows a spinner.
 */
export default function AuthCallback() {
  const { isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-neutral-600">Completing sign in...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Auth failed — redirect to login
  return <Navigate to="/login" replace />;
}
